import { useCallback, useState } from 'react';

export const useEarlyAccessModal = (initiallyOpen = false) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return {
    isOpen,
    openModal,
    closeModal
  };
};
